<article [attr.data-theme]="theme()" class="flex flex-col w-full border rounded-md theme-border" [class]="customClass()">
    <div class="flex flex-wrap items-center justify-between w-full px-5 py-3.5 cursor-pointer gap-2" (click)="toggle()">
        <div class="flex items-center gap-2 min-w-0">
            <div class="flex items-center gap-3">
                <p [attr.data-theme]="theme()" class="text-xl font-semibold theme-text truncate">
                    {{ label() }}
                    @if (count()) {
                        <span class="text-xl font-semibold text-primary">({{ count() }})</span>
                    }
                </p>
                @if (open()) {
                    <app-icon [attr.data-theme]="theme()" name="ic:round-keyboard-arrow-up" class="theme-text shrink-0" />
                } @else {
                    <app-icon [attr.data-theme]="theme()" name="ic:round-keyboard-arrow-down" class="theme-text shrink-0" />
                }
            </div>
            <div class="cursor-default" (click)="slotClick($event)">
                <ng-content select="[headerContent]" />
            </div>
        </div>
        <div class="flex items-center gap-2 cursor-default min-w-max ml-auto" (click)="slotClick($event)">
            <ng-content select="[buttons]" />
        </div>
    </div>
    @if (open()) {
        <div class="flex flex-col gap-6 px-5 py-3.5 pt-0">
            <app-divider />
            <ng-content />
        </div>
    }
</article>
